import { useEffect, useState } from "react";
import Close from "../../assets/UI Elements/Cross.svg";

const STORAGE_KEY = "cookieAccepted";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      const accepted = window.localStorage.getItem(STORAGE_KEY);
      if (accepted === "true") return;
    } catch (e) {}

    setShouldRender(true);

    const timer = setTimeout(() => {
      setVisible(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  if (!shouldRender) return null;

  const handleAccept = () => {
    if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem(STORAGE_KEY, "true");
      } catch (e) {}
    }
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  return (
    <div className="pointer-events-none fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-full px-4 flex justify-center">
      <div
        className={`pointer-events-auto max-w-[700px] grow p-4 flex flex-col md:flex-row items-center gap-4 rounded-[24px] border border-[#f4f1ff] bg-white/50 backdrop-blur-md leading-snug shadow-lg text-[14px] md:text-[16px] text-[#4d4d4d] transform transition-transform duration-500 ease-out ${
          visible ? "translate-y-0" : "translate-y-[120%]"
        }`}
      >
        <div className="grow flex flex-col gap-[2px]">
          <p>Мы используем cookie для статистики и улучшения сайта.</p>
          <p>
            Используя сайт, вы соглашаетесь с нашей{" "}
            <a href="/privacy-policy" className="underline">
              политикой конфиденциальности
            </a>
            .
          </p>
        </div>
        <div className="ml-2 flex flex-row-reverse md:flex-row jutify-center shrink-0 items-center gap-[20px] md:gap-[10px]">
          <button
            type="button"
            onClick={handleAccept}
            className="rounded-[12px] bg-[#946fff] px-3 py-1 font-medium text-white transition-colors hover:bg-[#7b57ff]"
          >
            Принять
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="h-[30px] w-[30px] flex items-center justify-center text-[#999999] transition-colors hover:text-[#666666]"
            aria-label="Закрыть уведомление о cookie"
          >
            <img src={Close} alt="Close" className="h-[20px] w-[20px]" />
          </button>
        </div>
      </div>
    </div>
  );
}
